import React from 'react';
import { Box } from '@mui/material';
import FormSettingRow from './FormSettingRow';
import EventPublishedSwitch from '../../widgets/EventPublishedSwitch';

const MemberMatchingField = ({ checked = false }) => (
  <Box
    sx={{
      pointerEvents: 'none',
      userSelect: 'none',
    }}
    aria-disabled="true"
  >
    <FormSettingRow
      dimmed
      title="Use Member Matching"
      description="Recommend attendees based on shared interests, goals, demographics, and event tags."
    >
      <EventPublishedSwitch
        checked={Boolean(checked)}
        disabled
        inputProps={{ 'aria-label': 'Use member matching' }}
      />
    </FormSettingRow>
  </Box>
);

export default MemberMatchingField;
